import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "list-section__item row gx-4 gx-xl-5" }
const _hoisted_2 = { class: "col-auto" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "fas fa-check"
}
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  key: 0,
  class: "list-section__item__headline"
}
const _hoisted_7 = { class: "list-section__item__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["list-section__item__icon", _ctx.iconClasses])
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            (_ctx.type === 'numbered')
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.itemNumber), 1))
              : _createCommentVNode("", true),
            (_ctx.type !== 'numbered')
              ? (_openBlock(), _createElementBlock("i", _hoisted_4))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.showHeadline)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "headline")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "content")
      ])
    ])
  ]))
}